import React, { FC } from 'react'
import { Order } from '../../types'
import { Config } from '../../common'
import { format, parseISO } from 'date-fns'
import pluralize from 'pluralize'
import ArrowIcon from '../../images/arrow-icon.svg'

interface Props {
  order: Order
  active: boolean
  onClick?: (order: Order) => void
}

const OrderSummaryListItem: FC<Props> = ({ order, active, onClick }) => (
  <div className="summary__list-item order-summary__list-item" onClick={() => onClick?.(order)}>
    <span>{format(parseISO(order.created_at), Config.OrderSummaryDateFormat)}</span>
    <span>
      {order.transfers.length} {pluralize('transfer', order.transfers.length)}
    </span>
    <span>#{order.id}</span>
    {!active && (
      <div className="summary__list-item__icon">
        <img src={ArrowIcon} alt="Arrow Icon" aria-hidden />
      </div>
    )}
  </div>
)

export default OrderSummaryListItem
